export const GoogleMapApiConfig = 'AIzaSyDnGyWRhl-wMg2LG_pyvQefqX98LmRwXHI';